export type Option = { id: any; name: string };

// Above this many options the list gets a filter box.
export const FILTER_THRESHOLD = 12;

export const SCROLL_THRESHOLD = 15;

export function needsFilter(options: Option[] = []): boolean {
  return options.length > FILTER_THRESHOLD;
}

export function needsScroll(options: Option[] = []): boolean {
  return options.length > SCROLL_THRESHOLD;
}

export function filterOptions(options: Option[] = [], query: string): Option[] {
  const term = (query || '').trim().toLowerCase();
  if (!term) return options;

  return options.filter(
    (option) => option && option.name && option.name.toLowerCase().indexOf(term) > -1
  );
}

export function toggleOption(selected: any[] = [], id: any, single = false): any[] {
  const isSelected = selected.indexOf(id) > -1;

  if (single) return isSelected ? [] : [id];

  return isSelected ? selected.filter((selectedId) => selectedId !== id) : [...selected, id];
}
